import { useAppBridge } from "@shopify/app-bridge-react";
import { useQuery } from "@tanstack/react-query";
import { API_BASE_URL } from "../../config";
import { useIsReady } from "../use-is-ready";

export const useIsInstalledOnShop = () => {
  const appBridge = useAppBridge();
  const isReady = useIsReady();
  const query = useQuery({
    queryKey: ["installed", appBridge.config.shop],
    queryFn: async ({ signal }) => {
      const token = await appBridge.idToken();
      const res = await fetch(`${API_BASE_URL}/is-installed`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        signal,
      });
      if (!res.ok) {
        return {
          isInstalled: false,
          plan: null,
        };
      }
      return res.json() as Promise<{ isInstalled: true; plan: "base" | "avanzato" | null }>;
    },
    enabled: isReady,
  });

  return query;
};
